<template>
    <v-row no-gutters align="center">
        <v-col :data-id="`total-${icon}`">
            {{ total }}
        </v-col>
        <v-col>
            <rider-icon :size="20">
                {{ icon }}
            </rider-icon>
        </v-col>
    </v-row>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import RiderIcon from '@/features/shared/RiderIcon.vue';

const props = defineProps<{
    value?: number;
    icon: string;
}>();

const total = computed(() => {
    return typeof props.value === 'number' ? props.value : '--';
});
</script>
